import { Overlay, Spinner } from "./Loading.styles";

const Loading = (): JSX.Element => (
    <Overlay>
        <Spinner className="loading" />
    </Overlay>
);

export default Loading;
